<template>
  <div class="h-full risk overflow-y-auto overflow-x-hidden">
    <!-- <div>
      <div class="flex justify-start items-start mb-10px mt-10px">
        <img src="../../assets/images/titleIcon.png" alt />
        <span class="text-16px text-white ml-4px">实时人车统计</span>
      </div>
      <div class="flex items-center">
        <img class="w-50px mr-5px" src="../../assets/images/control/person.png" alt />
        <div v-loading="personLoading" class="flex items-center flex-1">
          <div
            class="text-14px mr-8px"
            v-for="(item, index) in personList"
            :key="index"
            :class="{ 'cursor-pointer': item.label !== '访客人员' }"
            @click="openPersonList(item)"
          >
            <div class="flex mb-5px">
              <img
                class="mr-5px w-12px h-13px object-contain"
                src="../../assets/images/control/ornament.png"
                alt
              />
              <div class="text-white">{{ item.label }}</div>
            </div>
            <div class="text-hex-7ffbef ml-15px truncate flex" :title="item.num">
              <div class="max-w-50px truncate">{{ item.num }}</div>
              <div v-if="item.num !== '-'">人</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end my-10px">
        <img src="../../assets/images/control/line.png" alt />
      </div>
      <div class="flex items-center">
        <img class="w-50px mr-5px" src="../../assets/images/control/car.png" alt />
        <div v-loading="carLoading" class="flex items-center flex-1" @click="carVisible = true">
          <div
            class="text-14px mr-8px cursor-pointer"
            v-for="(item, index) in carList"
            :key="index"
            @click="openCarList(item.label === '内部车辆')"
          >
            <div class="flex mb-5px">
              <img
                class="mr-5px w-12px h-13px object-contain"
                src="../../assets/images/control/ornament.png"
                alt
              />
              <div class="text-white">{{ item.label }}</div>
            </div>
            <div class="text-hex-7ffbef ml-15px truncate flex" :title="item.num">
              <div class="max-w-50px truncate">{{ item.num }}</div>
              <div v-if="item.num !== '-'">辆</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10px" v-loading="alarmLoading">
      <div class="flex justify-between h-32px items-center">
        <div class="flex justify-start items-center mb-10px leading-32px h-32px">
          <img src="../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">今日实时报警</div>
        </div>
        <div
          class="charge-bg h-32px px-10px text-white cursor-pointer text-14px !leading-32px"
          @click="openAlarmList"
        >
          {{ alarmingCount }}/{{ todayAlarmCount }}今日报警
        </div>
      </div>
      <div class="flex">
        <div class="w-100px h-100px pie-bg">
          <v-chart
            v-loading="chartLoading"
            :options="pieOption"
            autoresize
            class="w-full h-full"
          ></v-chart>
        </div>
        <div class="flex flex-wrap flex-1 justify-between">
          <div
            class="w-110px h-25px relative text-14px pl-5px py-5px alarm-bg"
            v-for="(item, index) in alarmTypeList"
            :key="index"
          >
            <div class="absolute w-2px left-0 top-0">
              <div class="w-full h-8px" :style="`backgroundColor: ${item.color}`"></div>
              <div
                class="w-0px h-0px border-t-2px border-r-2px"
                :style="`borderColor: ${item.color} transparent transparent transparent`"
              ></div>
            </div>
            <div class="flex">
              <div class="text-hex-c0fbfe mr-5px">{{ item.label }}</div>
              <div class="flex">
                <div class="text-white w-30px truncate" :title="item.data">{{ item.data }}</div>
                <div class="text-hex-59bfbc">次</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="pt-10px h-full">
      <!-- tab切换 -->
      <div class="tab-bg h-50px flex text-14px items-center px-10px mb-10px">
        <div class="flex justify-between flex-1">
          <div
            class="text-hex-c0fafe cursor-pointer relative"
            v-for="(item, index) in dynamicList"
            :key="index"
            :class="{ 'text-hex-6eeae0': item.isChoosed }"
            @click="toggleTab(item.label)"
          >
            <div>{{ item.label }}</div>
            <div
              v-if="item.isChoosed"
              class="tab-isChoosed w-57px h-8px absolute -bottom-15px"
            ></div>
          </div>
        </div>
        <!-- <div
          class="charge-bg w-100px h-32px flex justify-center items-center text-white cursor-pointer"
        >
          需充电卡片1张
        </div>-->
      </div>
      <!-- 区域动态 -->
      <div v-show="currentTab === 'RiskArea'" class="h-[calc(100%-60px)]">
        <div class="mb-10px">
          <el-input
            placeholder="请输入关键字"
            v-model="areaKeyword"
            clearable
            @input="handleAreaInput"
          >
            <i
              class="el-input__icon el-icon-search cursor-pointer"
              slot="suffix"
              @click="findAreaList"
            ></i>
          </el-input>
        </div>
        <el-table
          :data="areaList"
          height="calc(100% - 46px)"
          class="!min-h-230px"
          @row-click="areaRowClick"
          :row-class-name="rowClass"
          v-loading="areaLoading"
        >
          <el-table-column label=" 区域" prop="area" show-overflow-tooltip>
            <div slot-scope="{ row }" class="flex items-center">
              <img
                src="../../assets/images/control/choosed_arrow.png"
                alt
                v-if="row.isChoosed"
                class="mr-5px h-10px"
              />
              <div class="max-w-115px truncate">{{ row.area }}</div>
            </div>
          </el-table-column>
          <el-table-column label="人数" prop="count" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <!-- 人员动态 -->
      <div v-show="currentTab === 'PersonnelList'" class="h-[calc(100%-60px)]">
        <div class="mb-10px flex items-center">
          <el-select v-model="searchStatus" popper-class="visualization-select-popper">
            <el-option label="在线" value="0"></el-option>
            <el-option label="离线" value="1"></el-option>
          </el-select>
          <el-input
            placeholder="请输入关键字"
            suffix-icon="el-icon-search"
            v-model.trim="personnelKeyword"
            @input="filterTreeData"
          ></el-input>
        </div>
        <div class="h-[calc(100%-334px)] min-h-230px">
          <cockpit-tree
            ref="treeRef"
            class="mt-10px overflow-auto pr-12px"
            v-loading="treeLoading"
            v-if="treeData.length"
            :treeLoading="treeLoading"
            :treeData="treeData"
            :customFilter="customFilter"
            :isExpandAll="true"
          >
            <template #btns="{ node }">
              <div
                class="flex items-center mr-15px cursor-pointer"
                @click="goLocation(node.data)"
                v-if="searchStatus === '0'"
              >
                <div class="h-14px w-15px location-icon mr-5px"></div>
                <span>定位</span>
              </div>
              <div class="flex items-center mr-15px cursor-pointer" @click="goRoute(node.data)">
                <div class="h-14px w-15px route-icon mr-5px"></div>
                <span>路线</span>
              </div>
            </template>
          </cockpit-tree>
        </div>
      </div>
      <!-- 访客动态 -->
      <div v-show="currentTab === 'visitor'" class="h-[calc(100%-60px)]">
        <div class="mb-10px">
          <el-input
            placeholder="请输入关键字"
            suffix-icon="el-icon-search"
            v-model="visitorKeyword"
          ></el-input>
        </div>
        <el-table
          :data="accessRecords"
          height="calc(100% - 76px)"
          class="!min-h-200px"
          :row-class-name="rowClass"
        >
          <el-table-column label="人员姓名" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="动作"
            prop="event"
            width="70"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="动作时间" prop="time" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          class="float-right pr-6px page-theme flex"
          background
          small
          @size-change="searchVisitorList"
          @current-change="getVisitorRecordsList"
          :current-page.sync="visitorPage.pageNo"
          layout="slot, prev, pager, next"
          :page-size.sync="visitorPage.pageSize"
          :total="visitorPage.total"
        >
          <template>
            <div class="inline-block h-24px leading-24px text-15px">
              共
              <span class="!leading-22px text-center text-hex-fbaf3d">{{ visitorPage.total }}</span
              >条数据
            </div>
          </template>
        </el-pagination>
      </div>
    </div>
    <person-alarm-list
      v-if="alarmListVisible"
      :alarmListVisible.sync="alarmListVisible"
    ></person-alarm-list>
    <!-- 人员列表（内部、外部） -->
    <person-list
      v-if="innerPersonVisible"
      :visible.sync="innerPersonVisible"
      personSource="inner"
    ></person-list>
    <person-list
      v-if="outsidePersonVisible"
      :visible.sync="outsidePersonVisible"
      personSource="outside"
    ></person-list>
    <!-- 车辆列表（内部、外部） -->
    <car-list v-if="innerCarVisible" :visible.sync="innerCarVisible" carSource="inner"></car-list>
    <car-list
      v-if="outsideCarVisible"
      :visible.sync="outsideCarVisible"
      carSource="outside"
    ></car-list>
    <!-- 人员在线定位地图-start -->
    <div class="btn-open-map flex justify-between items-center" @click="changeMapVisible">
      <i class="h-full" :class="mapVisible ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
      <span>人员地图</span>
    </div>
    <div
      class="w-347px h-278px fixed right-25px bottom-25px transition-all duration-300"
      :style="{ right: mapVisible ? '25px' : '-350px' }"
    >
      <div id="dyw-map-container" class="w-full h-full">
        <canvas id="dyw-map-canvas" width="347" height="278" class="rounded-5px"></canvas>
      </div>
    </div>
    <!-- 人员在线定位地图-end -->
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  forEach,
  map,
  assign,
  isEmpty,
  throttle,
  includes,
  filter,
  isNil,
  find,
  cloneDeep,
  get,
  max,
} from 'lodash'
import { PersonnelApi, StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import { AreaApi } from '@wiz-api/area-management'
import { VisitorApi } from '@wiz-api/visitor-management'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import CockpitTree from '@/components/cockpit/CockpitTree'
import personnelList from '../../assets/js/componentMethods/personnelList'
import riskArea from '../../assets/js/componentMethods/riskArea'

// 报警列表
const PersonAlarmList = () => {
  return import('./components/PersonAlarmList')
}

// 人员列表
const PersonList = () => {
  return import('./PersonList')
}

// 车辆列表
const CarList = () => {
  return import('./CarList')
}

const personnelApi = new PersonnelApi()
const areaApi = new AreaApi()
const standardAlarmRecordApi = new StandardAlarmRecordApi()
const visitorApi = new VisitorApi()
const personnelLocationApi = new PersonnelLocationApi()

export default {
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    onlineTagList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      todayAlarmCount: 0, // 今日报警总数
      alarmingCount: 0, // 报警中总数
      personLoading: false,
      carLoading: false,
      personList: [
        {
          label: '内部员工',
          num: '-',
        },
        {
          label: '外协人员',
          num: '-',
        },
        {
          label: '访客人员',
          num: '-',
        },
      ],
      carList: [
        {
          label: '内部车辆',
          num: '-',
        },
        {
          label: '外部车辆',
          num: '-',
        },
      ],
      chartLoading: false,
      pieOption: {
        backgroundColor: 'transparent',
        color: ['#6e66ac', '#e1775a', '#f3ad68', '#75f9ef', '#5bc572', '#fbe661', '#3a84f7'],
        title: {
          // eslint-disable-next-line no-useless-concat
          text: `${'{name|' + '报警总数' + '}\n{val|'}${0}}{unit|` + '次' + '}',
          top: 'center',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: 'white',
                padding: [5, 0, 0, 0],
              },
              val: {
                fontSize: 15,
                color: 'white',
                fontWeight: 'bold',
                padding: [-5, 0, 0, 0],
              },
              unit: {
                fontSize: 12,
                color: 'white',
                padding: [-7, 0, 0, 0],
              },
            },
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['58%', '70%'],
            center: ['50%', '50%'],
            data: [],
            hoverAnimation: false,
            label: {
              show: false,
            },
          },
        ],
      },
      // tab
      dynamicList: [
        // 默认选中区域动态
        {
          label: '区域动态',
          labelName: '风险区域',
          value: 'RiskArea',
          isChoosed: true,
        },
        {
          label: '人员动态',
          labelName: '人员',
          value: 'PersonnelList',
          isChoosed: false,
        },
        {
          label: '访客动态',
          labelName: '访客',
          value: 'visitor',
          isChoosed: false,
        },
      ],
      // 首次加载展示区域动态
      currentTab: 'RiskArea',
      areaKeyword: '',
      visitorKeyword: '',
      personnelKeyword: '',
      searchStatus: '0',
      areaList: [],
      areaLoading: false,
      visitorPage: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      treeLoading: false,
      treeData: [],
      alarmListVisible: false,
      alarmLoading: false,
      // 报警类型映射
      alarmTypeList: [
        {
          label: '非法进入',
          value: 0,
          data: 0,
          color: '#6e66ac',
        },
        {
          label: '非法离开',
          value: 1,
          data: 0,
          color: '#e1775a',
        },
        {
          label: '超员报警',
          value: 2,
          data: 0,
          color: '#f3ad68',
        },
        {
          label: '缺员报警',
          value: 3,
          data: 0,
          color: '#75f9ef',
        },
        {
          label: '停留报警',
          value: 4,
          data: 0,
          color: '#5bc572',
        },
        {
          label: '静止报警',
          value: 5,
          data: 0,
          color: '#fbe661',
        },
        {
          label: 'SOS报警',
          value: 6,
          data: 0,
          color: '#3a84f7',
        },
        {
          label: '跌落报警',
          value: 7,
          data: 0,
          color: '#fa00ff',
        },
      ],
      allVisitorRecordsList: [],
      transferProps: {
        personnelId: '',
      },
      // 所有的人员列表
      allPerson: [],
      clickAreaTimerOut: null,
      // 获取人员和车辆定时器
      personCarTimer: null,
      // 获取区域的定时器
      areaTimer: null,
      // 是否正在查看历史轨迹
      isHistoricalTrajectory: false,
      // 内部人员列表弹框的显隐
      innerPersonVisible: false,
      // 外部人员列表弹框的显隐
      outsidePersonVisible: false,
      // 内部车辆列表弹框的显隐
      innerCarVisible: false,
      // 外部车辆列表弹框的显隐
      outsideCarVisible: false,
      // 是否正在创建历史轨迹
      isCreating: false,
      isCurrentId: '',
      dywMap: require('../../assets/images/dyw_map.png'),
      mapVisible: true,
      onlinePerson: [],
      timer: null,
    }
  },
  computed: {
    // 出入记录
    accessRecords() {
      // 暂时关闭访客动态功能（待标签绑定访客功能完善）
      return []
      const result = []
      forEach(this.allVisitorRecordsList, (item) => {
        if (!isNil(item.visitingTime)) {
          result.push({
            name: item.name,
            event: '进入',
            time: dayjs(item.visitingTime).format('YYYY-MM-DD HH:mm:ss'),
            isChoosed: false,
          })
        }
        if (!isNil(item.visitEndTime)) {
          result.push({
            name: item.name,
            event: '离开',
            time: dayjs(item.visitEndTime).format('YYYY-MM-DD HH:mm:ss'),
            isChoosed: false,
          })
        }
      })
      // 时间降序
      return result.sort((a, b) => {
        return Date.parse(b.time) - Date.parse(a.time)
      })
    },
  },
  components: {
    CockpitTree,
    PersonAlarmList,
    PersonList,
    CarList,
  },
  async created() {
    // this.getUserStatistics()
    // this.getVehicleStatistics()
    // this.getVisitorRecordsList()
    this.getAlarmTotal()
    this.getAlarmList()
    this.findAreaList()
    this.getPersonnelList()
    // 十分钟刷新一次
    // this.personCarTimer = setInterval(() => {
    //   this.getUserStatistics()
    //   this.getVehicleStatistics()
    // }, 600000)
    // 一分钟刷新一次
    this.areaTimer = setInterval(() => {
      this.findAreaList()
    }, 60000)
  },
  mounted() {
    // 绘制人员在线地图
    this.canvasPersonMap()
    this.timer = setInterval(() => {
      this.canvasPersonMap()
    }, 3000)
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.addEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.addEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer)
  },
  methods: {
    // 获取人员统计
    // async getUserStatistics() {
    //   this.personLoading = true
    //   const [err, res] = await personnelLocationApi.getUserStatistics()
    //   if (!err && res.code == 0 && res.data) {
    //     this.personList[0].num = res.data.inner
    //     this.personList[1].num = res.data.outside
    //     this.personList[2].num = res.data.visitor
    //   }
    //   this.personLoading = false
    // },
    // 获取车辆统计（大亚湾不需要车辆统计功能）
    // async getVehicleStatistics() {
    //   this.carLoading = true
    //   const [err, res] = await personnelLocationApi.getVehicleStatistics()
    //   if (!err && res.code == 0 && res.data) {
    //     this.carList[0].num = res.data.inner
    //     this.carList[1].num = res.data.outside
    //   }
    //   this.carLoading = false
    // },
    // 获取历史访客列表
    async getVisitorRecordsList() {
      const [err, res] = await visitorApi.visitorRecordPagedListQuery({
        maxResultCount: this.visitorPage.pageSize,
        skipCount: (this.visitorPage.pageNo - 1) * this.visitorPage.pageSize,
      })
      if (!err && res) {
        this.allVisitorRecordsList = res.items
        this.visitorPage.total = res.totalCount
      }
    },
    // 获取报警列表
    async getAlarmList() {
      this.alarmLoading = true
      const [err, res] = await standardAlarmRecordApi.getList({
        startTime: dayjs()
          .startOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs()
          .endOf('date')
          .format('YYYY-MM-DD HH:mm:ss'),
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && res) {
        this.pieOption.series[0].data = map(this.alarmTypeList, (item) => {
          return {
            name: item.label,
            value: filter(res.items, ['alarmType', item.value]).length,
          }
        })
        ;(this.pieOption.title.text =
          `${'{name|' + '报警总数' + '}\n{val|'}${res.totalCount}}{unit|` + '次' + '}'),
          forEach(this.alarmTypeList, (item) => {
            item.data = filter(res.items, ['alarmType', item.value]).length
          })
      }
      this.alarmLoading = false
    },
    // 获取报警总数
    async getAlarmTotal() {
      const [err, res] = await standardAlarmRecordApi.statisticalAlarmTotals()
      if (!err && res) {
        this.alarmingCount = res.toDayNotalarmCount
        this.todayAlarmCount = res.toDayalarmCount
      }
    },
    openAlarmList() {
      this.alarmListVisible = true
    },
    filterTreeData: throttle(function customFn() {
      this.$refs.treeRef?.treeRefFilter({
        personnelKeyword: this.personnelKeyword,
        searchStatus: this.searchStatus,
      })
    }, 500),
    // 自定义过滤
    customFilter(value, data) {
      return includes(data.name, value.personnelKeyword)
    },
    // 获取人员动态数据
    async getPersonnelList() {
      this.treeLoading = true
      const [err, res] = await personnelApi.getOrganizationTreeWithUserList({
        isBind: true,
      })
      if (!err && res) {
        this.allPerson = cloneDeep(res)
        this.treeData = get(this.dealUserTree(cloneDeep(res), this.searchStatus === '0'), '0')
        this.treeLoading = false
      }
    },
    // 目录树子节点数据调整
    dealUserTree(userTreeData, isFilterOnline = true) {
      userTreeData = filter(userTreeData, (treeItem, index) => {
        const result = this.dealUserTree(treeItem.childen, isFilterOnline)
        treeItem.childen = result[0]
        treeItem.isExpand = result[1]
        treeItem.keyId = treeItem.organizationUnitId
        treeItem.name = treeItem.organizationUnitName
        if (treeItem.userList) {
          forEach(treeItem.userList, (userItem) => {
            userItem.keyId = treeItem.organizationUnitId + userItem.id
            userItem.organizationUnitId = treeItem.organizationUnitId
            userItem.organizationUnitName = treeItem.organizationUnitName
          })
          // 筛选出在线的人员
          if (isFilterOnline) {
            treeItem.userList = filter(treeItem.userList, (item) => {
              return find(this.onlineTagList, (it) => {
                return it === item.tagCode
              })
            })
          } else {
            // 筛选出离线的人员
            treeItem.userList = filter(treeItem.userList, (item) => {
              return !find(this.onlineTagList, (it) => {
                return it === item.tagCode
              })
            })
          }
          treeItem.childen.push(...treeItem.userList)
          if (treeItem.userList.length || treeItem.isExpand) {
            treeItem.isExpand = true
          }
        }
        return treeItem.userList.length || treeItem.isExpand
      })
      return [
        userTreeData,
        find(userTreeData, (item) => {
          return item.isExpand
        }),
      ]
    },
    // 切换tab栏
    toggleTab(currentLabel) {
      forEach(this.dynamicList, (item) => {
        if (item.label === currentLabel) {
          item.isChoosed = true
          this.currentTab = item.value
        } else {
          item.isChoosed = false
        }
      })
    },
    // 切换区域
    toggleArea(id) {
      forEach(this.areaList, (item) => {
        if (item.id === id) {
          item.isChoosed = true
        } else {
          item.isChoosed = false
        }
      })
    },
    // 切换访客
    toggleVisitor(id) {
      forEach(this.accessRecords, (item, index) => {
        if (item.id === id) {
          this.$set(this.accessRecords, index, { ...item, isChoosed: true })
        } else {
          this.$set(this.accessRecords, index, { ...item, isChoosed: false })
        }
      })
    },
    // 人员动态定位
    goLocation(data) {
      // 如果正在查看历史轨迹，提示退出
      if (this.isHistoricalTrajectory) {
        return this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
      }
      const label = find(this.labelList, ['code', 'PersonnelList'])
      if (!label.checked) {
        return this.$message.warning({
          showClose: true,
          message: '没有勾选人员标签，请先勾选',
        })
      }
      personnelList.openPersonnelDetail(data.id, data.tagCode)
    },
    // 人员动态路线
    goRoute(data) {
      if (this.isCurrentId === data.id) return
      if (this.isCreating) {
        return this.$message.warning({
          showClose: true,
          message: '上一个人员数据未加载完，请稍后',
        })
      }
      this.isCreating = true
      this.isCurrentId = data.id
      this.$emit('operateTrajectory', {
        visible: true,
        personnelId: data.id,
        tagCode: data.tagCode,
      })
    },
    // 获取区域动态列表
    async findAreaList() {
      // 第一次请求的时候有loading效果
      if (isNil(this.areaTimer)) this.areaLoading = true
      personnelLocationApi.syncChronousPosition()
      const [err, res] = await personnelLocationApi.getArea({
        keyWord: this.areaKeyword,
        modelId: this.sourceId,
      })
      if (!err && res) {
        this.areaList = map(res, (item) => {
          return {
            ...item,
            isChoosed: false,
          }
        })
      }
      this.areaLoading = false
    },
    // 搜索访客动态列表
    searchVisitorList() {
      this.visitorPage.pageNo = 1
      this.getVisitorRecordsList()
    },
    // 点击区域行
    async areaRowClick(row) {
      // 如果正在查看历史轨迹，提示退出
      if (this.isHistoricalTrajectory) {
        return this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
      }
      // 清空人员定位相关操作
      this.clearOperate()
      // 移动到区域视角
      this.moveToArea(row)
      // 切换选中
      this.toggleArea(row.id)
    },
    // 点击定位到区域位置
    async moveToArea(row) {
      if (this.clickAreaTimerOut) clearTimeout(this.clickAreaTimerOut)
      this.clickAreaTimerOut = setTimeout(async () => {
        this.checkLabel(this.currentTab)
        if (row && row.playerVisualAngleJson) {
          await this.cloudRender.Camera.moveCamera(
            'CameraParam',
            JSON.parse(row.playerVisualAngleJson)
          )
        } else if (row) {
          riskArea.moveToArea(row.id)
        }
      }, 500)
    },
    // 获取table每一行的class
    rowClass({ row }) {
      if (row.isChoosed) {
        return 'table-choosed'
      }
      return ''
    },
    // 清空人员定位操作
    clearOperate() {
      // 取消跟随
      const cancelFollowEvent = new CustomEvent('cancelFollow')
      window.dispatchEvent(cancelFollowEvent)
    },
    // 检查对象标签是否打开，如果没打开就打开
    checkLabel(value) {
      const label = find(this.labelList, ['code', value])
      const labelName = get(find(this.dynamicList, ['value', value]), 'labelName', '')
      if (!label) {
        return this.$message.warning({
          showClose: true,
          message: `没有配置${labelName}标签，请配置`,
        })
      }
      // 如果没有打开对应功能标签，则打开
      if (!label.checked) {
        const filterEvent = new CustomEvent('setLabelChecked', {
          detail: {
            code: value,
            checked: true,
          },
        })
        window.dispatchEvent(filterEvent)
      }
    },
    // 输入搜索区域
    handleAreaInput() {
      _.throttle(this.findAreaList, 1000)()
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isHistoricalTrajectory = e.detail?.isOpen
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialEndHandler() {
      this.isCreating = false
    },
    // 监听历史轨迹是否加载完成
    loadHistoryTrialHandler() {
      this.isCreating = true
    },
    // 打开人员列表弹框
    openPersonList(item) {
      if (item.label === '访客人员') return
      this.innerPersonVisible = false
      this.outsidePersonVisible = false
      this.innerCarVisible = false
      this.outsideCarVisible = false
      if (item.label === '内部员工') {
        this.innerPersonVisible = true
      } else {
        this.outsidePersonVisible = true
      }
    },
    // 打开车辆列表弹框
    openCarList(isInner) {
      this.innerPersonVisible = false
      this.outsidePersonVisible = false
      this.innerCarVisible = false
      this.outsideCarVisible = false
      if (isInner) {
        this.innerCarVisible = true
      } else {
        this.outsideCarVisible = true
      }
    },
    // canvas人员在线地图
    canvasPersonMap() {
      const canvas = document.getElementById('dyw-map-canvas')
      if (!canvas) return
      const onlinePersonList = personnelList.onlinePerson()
      if (onlinePersonList && onlinePersonList?.length > 0) {
        this.onlinePerson = onlinePersonList.map((item) => {
          const { canvasX, canvasY } = this.mapToCanvas(canvas.width, canvas.height, item.x, item.y)
          return {
            name: item.name,
            x: canvasX,
            y: canvasY,
          }
        })
      }
      this.initCanvas(canvas, this.onlinePerson)
    },
    /**
     * 初始化绘制canvas
     * @param {*} canvas 画布对象
     * @param {*} personList 在线人员列表
     */
    initCanvas(canvas, personList) {
      const ctx = canvas.getContext('2d')
      // 创建一个新的图像对象
      const img = new Image()
      img.src = this.dywMap
      // 当图像加载完成后进行绘制
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height) // 清除画布
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        // 绘制人员的名字
        personList.forEach((person) => {
          if (
            person.x >= 0 &&
            person.x <= canvas.width &&
            person.y >= 0 &&
            person.y <= canvas.height
          ) {
            const fontSize = 14 // 设置字体大小
            const pointSize = 3 // 设置圆点大小
            ctx.font = `${fontSize}px Arial`
            // 设置高亮效果，绘制矩形背景
            ctx.fillStyle = '#005d6588' // 设置高亮背景颜色
            const textWidth = ctx.measureText(person.name).width + 6 // 获取文本宽度
            const rectHeight = 18 // 设置矩形高度
            let rectX // 计算矩形的 x 坐标
            let rectY // 计算矩形的 y 坐标
            if (person.x + 10 + textWidth > canvas.width) {
              rectX = person.x - 10 - textWidth
            } else {
              rectX = person.x + 10
            }
            if (person.y - rectHeight / 2 < 0) {
              rectY = 0
            } else if (person.y + rectHeight / 2 > canvas.height) {
              rectY = canvas.height - rectHeight
            } else {
              rectY = person.y - rectHeight / 2
            }
            ctx.fillRect(rectX, rectY, textWidth, rectHeight) // 绘制背景矩形

            // 绘制圆点
            ctx.fillStyle = 'red' // 设置圆点颜色
            ctx.beginPath() // 开始绘制路径
            ctx.arc(person.x, person.y, pointSize, 0, Math.PI * 2) // 绘制圆
            ctx.fill() // 填充圆

            // 绘制文本
            ctx.fillStyle = 'yellow' // 设置文本颜色
            const textX = rectX + 3
            let textY // 计算文本的 y 坐标
            if (person.y - rectHeight / 2 < 0) {
              textY = fontSize
            } else if (person.y + rectHeight / 2 > canvas.height) {
              textY = canvas.height - rectHeight + fontSize
            } else {
              textY = person.y - rectHeight / 2 + fontSize
            }
            ctx.fillText(person.name, textX, textY) // 在指定位置绘制文本
          }
        })
      }
    },
    /**
     * 坐标转换
     * @param {*} canvasWidth 画布宽度
     * @param {*} canvasHeight 画布高度
     * @param {*} x 需要转换的x坐标
     * @param {*} y 需要转换的y坐标
     */
    mapToCanvas(canvasWidth, canvasHeight, x, y) {
      const actualMinX = -429.699223
      const actualMinY = -471.349257
      const actualMaxX = 181.779426
      const actualMaxY = 123.336228
      // 实际区域宽度 = 右上角x - 左下角x = 181.779426 - (-429.699223) = 611.478649
      // 实际区域高度 = 右上角y - 左下角y = 123.336228 - (-471.349257) = 594.685485
      const actualWidth = actualMaxX - actualMinX
      const actualHeight = actualMaxY - actualMinY

      // const canvasWidth = 347
      // const canvasHeight = 278

      const canvasX = ((x - actualMinX) / actualWidth) * canvasWidth
      const canvasY = canvasHeight - ((y - actualMinY) / actualHeight) * canvasHeight

      return { canvasX, canvasY }
    },
    changeMapVisible() {
      this.mapVisible = !this.mapVisible
    },
  },
  watch: {
    currentTab: {
      immediate: true,
      handler(value) {
        // 暂时访客不做处理
        if (value === 'visitor') return
        this.checkLabel(value)
      },
    },
    searchStatus(value) {
      this.treeLoading = true
      this.treeData = get(this.dealUserTree(cloneDeep(this.allPerson), value === '0'), '0')
      this.$nextTick(() => {
        this.treeLoading = false
      })
    },
    onlineTagList() {
      this.treeLoading = true
      if (this.searchStatus === '0') {
        this.treeData = get(this.dealUserTree(cloneDeep(this.allPerson), true), '0')
      }
      this.$nextTick(() => {
        this.treeLoading = false
      })
    },
  },
  beforeDestroy() {
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    window.removeEventListener('loadHistoryTrialEnd', this.loadHistoryTrialEndHandler)
    window.removeEventListener('loadHistoryTrial', this.loadHistoryTrialHandler)
    if (this.personCarTimer) clearInterval(this.personCarTimer)
    if (this.areaTimer) clearInterval(this.areaTimer)
    if (this.clickAreaTimerOut) clearTimeout(this.clickAreaTimerOut)
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/control.scss';

::v-deep .el-loading-mask {
  background-color: #0f393f;
}

.tab-bg {
  background: url('../../assets/images/control/tab.png');
  background-size: 100% 100%;
}

.charge-bg {
  background: url('../../assets/images/control/charge.png');
  background-size: 100% 100%;
}

.tab-isChoosed {
  background: url('../../assets/images/control/tab_choosed.png');
  background-size: 100% 100%;
}

.pie-bg {
  background: url('../../assets/images/control/pie_bg.png');
  background-size: 100% 100%;
}

.alarm-bg {
  background: url('../../assets/images/control/alarm_bg.png');
  background-size: 100% 100%;
}

.head-bg {
  background: url('../../assets/images/control/table_head.png');
  background-size: 100% 100%;
}

::v-deep .table-choosed {
  background: url('../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
  color: #93eaff;
}

.user-icon {
  background: url('../../assets/images/control/user.png');
  background-size: 100% 100%;
}

.location-icon {
  background: url('../../assets/images/control/location.png');
  background-size: 100% 100%;
}

.route-icon {
  background: url('../../assets/images/control/route.png');
  background-size: 100% 100%;
}

.area-box {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 9px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #104a70;
    color: #104a70;
  }
}

.page-theme {
  ::v-deep {
    button[class^='btn-'] {
      width: 24px;
      height: 24px;
    }

    .btn-prev,
    .btn-next {
      background-color: #345479;
      color: #fff;
    }

    .el-pager {
      li {
        min-width: 24px !important;
        height: 24px;
        margin: 0 3px 0 3px !important;
        line-height: 24px;
        border-radius: 3px;
        border: 1px solid rgba(141, 194, 255, 0.28);
      }
    }
  }
}

.btn-open-map {
  width: 85px;
  font-size: 14px;
  text-align: center;
  position: fixed;
  padding: 5px;
  bottom: 275px;
  right: -65px;
  cursor: pointer;
  color: #ffffff;
  background-color: #103a44b2;
  border-radius: 5px;
  z-index: 9999;
  transition: right 0.3s;

  &:hover {
    right: 0;
    background-color: #103a44;
  }
}
</style>
